import React from "react";
import classnames from "classnames";

export default function RequiredMark({
	required,
	asterisksClass,
}: {
	required?: boolean;
	asterisksClass?: string;
}) {
	if (!required) {
		return null;
	}

	const asterisksClassName = classnames(
		"form__field__required",
		asterisksClass
	);

	return <span className={asterisksClassName}>*</span>;
}
